import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// Component
import { PublicidadComponent } from './publicidad/publicidad.component';
import { MediaComponent } from './media/media.component';
import { ReelsComponent } from './reels/reels.component';
import { UnitsComponent } from './units/units.component';
import { GroupsComponent } from './groups/groups.component';
import { ReelCategoriesComponent } from './reel-categories/reel-categories.component';
import { EvidencesComponent } from './evidences/evidences.component';
import { LayoutsComponent } from './layouts/layouts.component';
import { UsersComponent } from './users/users.component';
import { RolesGuard } from '../../../guards/roles.guard';
import { MediaKpiComponent } from './media-kpi/media-kpi.component';
import { HerramientasComponent } from './herramientas/herramientas.component';
import { ReportKpiComponent } from './report-kpi/report-kpi.component';
import { DesignReelsComponent } from '../../client/configurations/design-reels/design-reels.component';
import { MediaClientComponent } from './media-client/media-client.component';
import { CompanyClientComponent } from './company-client/company-client.component';
import { BannerComponent } from './banner/banner.component';
import { LayoutDesignerComponent } from './layout-designer/layout-designer.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: 'media',
    pathMatch: 'full'
  },
  {
    path: 'media',
    component: MediaComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Media'
    }
  },
  {
    path: 'banner',
    component: BannerComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Banner'
    }
  },
  {
    path: 'media-client',
    component: MediaClientComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Clientes'
    }
  },
  {
    path: 'company-client',
    component: CompanyClientComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Compañia                                                  '
    }
  },
  {
    path: 'reels',
    component: DesignReelsComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Campañas'
    }
  },
  {
    path: 'reels/:id',
    component: ReelsComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Campañas'
    }
  },
  {
    path: 'units',
    canActivate: [RolesGuard],
    component: UnitsComponent,
    data: {
      title: 'Unidades'
    }
  },
  {
    path: 'groups',
    component: GroupsComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Grupo de Unidades'
    }
  },
  {
    path: 'reel-categories',
    component: ReelCategoriesComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Categorias de Campañas'
    }
  },
  {
    path: 'reel-evidences/:id',
    component: EvidencesComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Evidencias de Campañas'
    }
  },
  {
    path: 'layouts',
    component: LayoutsComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Layouts'
    }
  },
  {
    path: 'layouts-designer',
    component: LayoutDesignerComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Layouts'
    }
  },
  {
    path: 'media-kpi',
    component: MediaKpiComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Estadisticas'
    }
  },
  {
    path: 'report-kpi',
    component: ReportKpiComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Estadisticas'
    }
  },
  {
    path: 'herramientas',
    component: HerramientasComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Herramientas'
    }
  },
  {
    path: 'usuarios',
    component: UsersComponent,
    canActivate: [RolesGuard],
    data: {
      title: 'Usuarios'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SvsRoutingModule { }
